"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
import { useEffect } from "react";
import { APP_THEME_COLOR_DARK, APP_THEME_COLOR_LIGHT } from "@/app/site-config";
const META_SELECTOR = 'meta[name="theme-color"]:not([media])';
function ensureMeta(): HTMLMetaElement {
  let meta = document.head.querySelector<HTMLMetaElement>(META_SELECTOR);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "theme-color");
    document.head.appendChild(meta);
  }
  return meta;
}
export function ThemeColorSync() {
  const $ = _c(3);
  const {
    resolvedTheme
  } = useTheme();
  let t0;
  let t1;
  if ($[0] !== resolvedTheme) {
    t0 = () => {
      if (!resolvedTheme) {
        return;
      }
      const color = resolvedTheme === "dark" ? APP_THEME_COLOR_DARK : APP_THEME_COLOR_LIGHT;
      ensureMeta().setAttribute("content", color);
    };
    t1 = [resolvedTheme];
    $[0] = resolvedTheme;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}